import React from "react";
import styled from "styled-components";
import { Flex } from "../../../components/Flex";
import { Breakpoints } from "../../../theme/Breakpoints";
import { Rounded } from "../../../theme/Rounded";
import { Shadow } from "../../../theme/Shadow";
import { Spacing } from "../../../theme/Spacing";

const Section = styled(Flex)`
  flex-direction: column;
  gap: ${Spacing.s};
  padding: ${Spacing.m};
  padding-top: 0;
  position: relative;
`;

const Container = styled(Flex)`
  background-color: ${(props) => props.theme.white};
  border-radius: ${Rounded.md};
  box-shadow: ${Shadow.SM};
`;

const ContentWrapper = styled(Flex)`
  flex-direction: column;
  gap: ${Spacing.m};
  padding: ${Spacing.m};
  width: 100%;

  @media (min-width: ${Breakpoints.DESKTOP}) {
    width: 70%;
  }
`;

type Props = {
  children: React.ReactNode;
};

export const SettingsWrapper: React.FC<Props> = ({ children }) => {
  return (
    <Section>
      <Container>
        <ContentWrapper>{children}</ContentWrapper>
      </Container>
    </Section>
  );
};
